import { useMutation } from '@tanstack/react-query';

import { managerTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';

export const setManagerTelegram: managerTypes.SetManagerTelegram = (data) => {
  return axios.put(`/manager/telegram`, data);
};

type UseSetManagerTelegramOptions = {
  department: Departments;
  config?: MutationConfig<typeof setManagerTelegram>;
};

export function useSetManagerTelegram({ config = {}, department }: UseSetManagerTelegramOptions) {
  return useMutation({
    ...config,
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['managers', department]);
      config.onSuccess && config.onSuccess(...params);
    },
    mutationFn: setManagerTelegram,
  });
}
